import { Skeleton } from "@/components";
import { BackAppBar } from "@/components/ui";
import { isMpisAccount } from "@/libraries/helper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useLoaderDeps } from "@tanstack/react-router";

const PendingComponentMembers = ({
	title = "Invite Member",
}: { title?: string }) => {
	const tab = useLoaderDeps({
		// @ts-expect-error
		strict: false,
		// @ts-expect-error
		select: (s) => s.tab,
	});
	return (
		<>
			<BackAppBar title={title}>
				<div className="container pb-2 space-y-4">
					<Tabs
						centered
						value={tab}
						variant="fullWidth"
						textColor="inherit"
						aria-label="Contact Type"
						className="!rounded-full !bg-gray-light [&_.MuiTabs-indicator]:!bg-transparent !p-1"
					>
						<Tab
							value="contact"
							label="Contacts"
							classes={{
								selected: "!bg-white !rounded-full",
							}}
						/>
						<Tab
							value="directory"
							label="Directory"
							classes={{
								selected: "!bg-white !rounded-full",
							}}
						/>
						{isMpisAccount() ? (
							<Tab
								value="mpis"
								label="MPIS"
								classes={{
									selected: "!bg-white !rounded-full",
								}}
							/>
						) : null}
					</Tabs>
				</div>
			</BackAppBar>
			<div className="relative flex-1 bg-white overflow-y-auto flex flex-col gap-3">
				<Skeleton className="h-14 w-full" />
				<Skeleton className="h-14 w-full" />
				<Skeleton className="h-14 w-full" />
				<Skeleton className="h-14 w-full" />
			</div>
		</>
	);
};

export default PendingComponentMembers;
